const isPDP = window.location.href.includes("/products");

function startObserverOnVariantSelection() {
  const targetNode = document.querySelector('variant-selection');
  if (!targetNode) return;

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'variant'
      ) {
        if (isPDP) {
          const productForm = document.querySelector("[bss-b2b-main-product-form]");
          BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
        } else {
          const productForm = document.querySelector("[bss-b2b-quickview-product-form]");
          BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
          document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`));
        }
        
      }
    }
  });

  observer.observe(targetNode, {
    attributes: true,
    attributeFilter: ['variant'],
  });
}

if (isPDP) {
  startObserverOnVariantSelection();
} else {
  const quickshopBtns = document.querySelectorAll('.product-thumbnail__quickshop-button');
  quickshopBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      setTimeout(() => {
        startObserverOnVariantSelection();
      }, 1500); 
    });
  });
}


const modalElement = document.querySelector('.modal');

if (modalElement) {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class' && mutation.target.className === "modal modal--quickshop") {
        const productForm = document.querySelector("[bss-b2b-quickview-product-form]");
          BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
        document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`));
      }
    }
  });

  observer.observe(modalElement, {
    attributes: true,
    attributeFilter: ['class'] 
  });
}
